import React, { PureComponent } from 'react'
import iconActiveTopics from '../images/icon-filled-active-topics.svg'
import iconAnswers from '../images/icon-filled-answers.svg'
import iconSupports from '../images/icon-filled-supports.svg'
import DiscussionHeroImg from '../images/discussion-hero-img.png';
import DiscussionTopicBlock from './discussion/discussion-topic-block'
import NavBar from './navigation/nav-bar'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import styled from 'styled-components'
import { TABLET, LAPTOP } from '../utilities/breakpoints'
import { formPagePath } from '../utilities/route'

class DialoguePageFront extends PureComponent {

  t = (phrase) => {
    const { useTranslate } = this.props
    return useTranslate(`discussion.${phrase}`)
  }

  render() {
    const {
      history,
      match: {
        params: { surveyId, languageCode },
      },
      useTranslate,
      questionnaire: {
        logo,
        canViewAfterGame,
        isAfterGameGuest,
        isDialogueActive,
        areProgressReportsActive
      },
      afterGameDialogueTopics,
      afterGameDialogueTotalStatistics,
      improvementProject,
    } = this.props;

    const toDiscussionTopic = formPagePath(languageCode, surveyId, 'finish', 'dialogue', 'topic');

    // Handle redirects if discussion is not active
    if (!isDialogueActive && (canViewAfterGame || isAfterGameGuest)) {
      history.push(formPagePath(languageCode, surveyId, 'finish'));
    } else if (!isDialogueActive && !canViewAfterGame && !isAfterGameGuest) {
      history.push(formPagePath(languageCode, surveyId));
    }

    const { activeTopicsCount, answersCount, likesCount } = afterGameDialogueTotalStatistics;
    const activeTopics = afterGameDialogueTopics.filter((topic) => topic.active);
    const closedTopics = afterGameDialogueTopics.filter((topic) => !topic.active);

    return (
      <section className="discussion-page">
        <DiscussionPageHeader>
          <div className="aftergame-page-container">
            <NavBar
              afterGame logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"discussion"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="discussion-page__container">
            <div className="finish-page__intro">
              <h1>{this.t("discussion_title")}</h1>
              <div className="stats-description">
                <p>{this.t("discussion_description")}</p>
              </div>
            </div>
          </div>
          <HeroImg>
            <img src={DiscussionHeroImg} alt="Shapes"/>
          </HeroImg>
        </DiscussionPageHeader>
        <DiscussionPageContent>
          <div className="discussion-page__container">
            <div className="discussion-stats">
              <div className="row justify-content-between">
                <div className="col-auto">
                  <div className="stat-item">
                    <img src={iconActiveTopics} alt="Icon"/>
                    <div className="data">
                      {this.t("active_topics")}
                      <span className="amount">
                      {activeTopicsCount}
                    </span>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="stat-item">
                    <img src={iconAnswers} alt="Icon"/>
                    <div className="data">
                      {this.t("Answers")}
                      <span className="amount">{answersCount}</span>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="stat-item">
                    <img src={iconSupports} alt="Icon"/>
                    <div className="data">
                      {this.t("Supports")}
                      <span className="amount">{likesCount}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {activeTopics.map((i, index) => (
              <DiscussionTopicBlock
                {...i}
                closed={!i.active}
                title={i.title}
                questions={i.questions}
                toDiscussionTopic={`${toDiscussionTopic}/${i.id}`}
                key={index}
                isAfterGameGuest={isAfterGameGuest}
              />
            ))}
            {closedTopics.length > 0 &&
              <ClosedTopics>
                <h4>{this.t("closed_topics_title")}</h4>
                {closedTopics.map((i, index) => (
                  <DiscussionTopicBlock
                    {...i}
                    closed={!i.active}
                    title={i.title}
                    questions={i.questions}
                    toDiscussionTopic={`${toDiscussionTopic}/${i.id}`}
                    key={index}
                    isAfterGameGuest={isAfterGameGuest}
                  />
                ))}
              </ClosedTopics>
            }
          </div>
        </DiscussionPageContent>
      </section>

    )
  }

}

export default DialoguePageFront;

const DiscussionPageHeader = styled.div`
  position: relative;
  background-color: #CCE2F2;
  padding-bottom: 60px;
  
  .nav-aftergame {
    z-index: 2;
  }
  
  .stats-description p {
    z-index: 1;
  }
  
  @media${TABLET} {
    padding-bottom: 80px;
  }
`;

const DiscussionPageContent = styled.div`
  position: relative;
  margin-top: -50px;
  
  @media${LAPTOP} {
    margin-top: -70px;
  }
`;

const ClosedTopics = styled.div`
  padding-top: 40px;
  h4 {
    margin-bottom: 20px;
    font-size: 18px;
  }
  
  @media${TABLET} {
    h4 {
      margin-bottom: 20px;
      font-size: 20px;
    }
  }
`;

const HeroImg = styled.div`
  display: none;
  
  @media${TABLET} {
    display: block;
    position: absolute;
    z-index: 0;
    right: 0;
    top: 0;
    
    img {
      width: 400px;
      height: auto;
    }
  }
  
  @media${LAPTOP} {
    img {
      width: 460px;
      height: auto;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/dialogue-page-front.js